/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
// import { MathComponent } from "mathjax-react";
import ReactMarkdown from 'react-markdown'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' 

import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

import Abstract from "./Abstract.js";
import ImageResults from "./ImageResults.js";
// import Results from "./Results.js";
// import Comparison from "./Comparison.js";
import teaser from './images/fig1-crop.jpg';
import task from './images/task.jpg';
import method from './images/refpaint-crop.jpg';
// import video_website from "./video/video-website.mp4";

import subsection_style from "./style.js";


const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled
 * components for such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="SinNeRF"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "0.5em" : "1em",
      }}
    /> */}
    <Header
      as="h1"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1em",
      }}
    >
      <div>
      Reference-based Painterly Inpainting via Diffusion: <br />
Crossing the Wild Reference Domain Gap
      </div>
    </Header>
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
};

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Media greaterThan="mobile">
        <HomepageHeading />
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <HomepageHeading mobile />

        {children}
      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};


const str = `Given input quadruplets ($I_r, I_{bg}, M_o, M_{bg}$) that consists of an object-centric reference image $I_r \\in R^{H_r \\times W_r \\times 3}$, a background image $I_{bg} \\in R^{H_{bg} \\times W_{bg} \\times 3}$ and their corresponding binary masks $M_o \\in R^{H_o \\times W_r \\times 1}$ and $M_{bg} \\in R^{H_{bg} \\times W_{bg} \\times 3}$, the goal is to inpaint the input object $I_r$ into the masked region $I_{bg} \\times M_{bg}$. We utilize a ladder-side branch and a masked fusion block to incorporate additional mask information. The framework is trained in a self-supervised manner.` 

const ResponsiveContainer = ({ children }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const HomepageLayout = ({ mobile }) => (
  <ResponsiveContainer>
    <div>
      <Container text>
        <Grid
          container
          stackable
          verticalAlign="middle"
          columns={4}
          textAlign="center"
          style={{
            fontSize: "1em",
            fontWeight: "normal",
            marginTop: "0.5em",
            marginBottom: "0.5em",
          }}
        >
          <a href="https://ir1d.github.io/" target="_blank" rel="noreferrer">
            Dejia Xu<sup>1</sup>
          </a>
          <a
            href="https://xingqian2018.github.io"
            target="_blank"
            rel="noreferrer"
          >
            Xingqian Xu<sup>2,3</sup>
          </a>
          <a href="https://wenyancong.com/" target="_blank" rel="noreferrer">
            Wenyan Cong<sup>1</sup>
          </a>
          <a href="https://wenyancong.com/" target="_blank" rel="noreferrer">
           Humphrey Shi<sup>2,3</sup>
          </a>
          <a
            href="https://express.adobe.com/page/CAdrFMJ9QeI2y/"
            target="_blank"
            rel="noreferrer"
          >
            Zhangyang Wang<sup>1,3</sup>
          </a>
        </Grid>
        <Grid
          container
          stackable
          verticalAlign="middle"
          columns={4}
          textAlign="center"
          style={{
            fontSize: "1em",
            fontWeight: "normal",
          }}
        >
          {/* <a
            href="https://www.humphreyshi.com/"
            target="_blank"
            rel="noreferrer"
          >
            Humphrey Shi<sup>2,3,4</sup>
          </a>
           */}
          <div style={{
            fontSize: "0.9em",
            fontWeight: "normal",
          }}>
            <sup>1</sup> The University of Texas at Austin, 
            <sup>2</sup> SHI Labs @ Georgia Tech & UIUC,
            <sup>3</sup> Picsart AI Research (PAIR)
          </div>
          <br />
        </Grid>
      </Container>
      <Grid
        container
        stackable
        verticalAlign="middle"
        columns={2}
        width={10}
        textAlign="center"
        style={{
          fontSize: "1.2em",
          fontWeight: "normal",
          marginTop: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        <Grid.Row>
          <Grid.Column columns={2}>
            <Button primary icon>
              <a
                href="https://arxiv.org/abs/2307.10584"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="book" />
                {" Paper"}
              </a>
            </Button>
            <Button primary icon>
              <a
                href="https://github.com/Ir1d/RefPaint"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="github" />
                {" Code"}
              </a>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Container text>
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Video
          </Header>
          <video
          src={video_website}
          width="100%"
          loop="loop"
          autoplay=""
          controls
        ></video> */}
        <Image src={teaser} style={subsection_style}></Image>
        <p>
        <b>TL;DR:</b> Our proposed <u>Ref</u>erence-based <u>Paint</u>erly Inpainting framework (RefPaint) allows controlling the strength of reference semantics and background style when performing inpainting. Compared to Stable Diffusion, which uses text prompts as the reference, our RefPaint captures the reference information better and is able to generate consistent styles.
        </p>
        <Abstract mobile={mobile} />
        <Header as="h2" textAlign="center" style={subsection_style}>
          Task Comparison
        </Header>

        <Image src={task} style={subsection_style}></Image>
        <Header as="h2" textAlign="center" style={subsection_style}>
          Method Overview
        </Header>
        <Image src={method} style={subsection_style}></Image>

        <ReactMarkdown remarkPlugins={[remarkMath]}
    rehypePlugins={[rehypeKatex]}
>{str}</ReactMarkdown>
        <Header as="h2" textAlign="center" style={subsection_style}>
          Results
        </Header>
        <ImageResults />
        <Header as="h2" textAlign="center" style={subsection_style}>
          Citation
        </Header>
        <p style={{ paddingBottom: "0.5em", overflow: "auto" }}>
          If our work is helpful for you, please cite:
          <pre>
            <code>
              {`@article\{xu2023refpaint,
    author = \{\},
    title = \{Reference-based Painterly Inpainting via Diffusion: Crossing the Wild Reference Domain Gap\},
    journal={arxiv preprint},
    year={2023}
\}`}
            </code>
          </pre>
        </p>
      </Container>
    </div>
  </ResponsiveContainer>
);

export default HomepageLayout;
